// PrefabEditModal — edit a prefab from the content browser (double-click a
// prefab card, or right-click → Edit). Wraps the same PrefabDetail form the
// Blueprint editor's Composer uses, so there is one prefab editor, not two.
//
// A FloatingWindow, not a modal: editing a prefab is work you do against the
// asset grid behind it (which clip? which audio?), and a scrim that hides the
// grid answers the question by blocking it. Draggable, resizable, poppable to
// a second monitor; the name survives as the file name it edits.
//
// Save/Delete go through CustomAssetManager (which PATCHes the asset-manager
// and re-loads the clip into the runtime). A successful save or delete closes
// the modal; an error is surfaced inline by PrefabDetail and keeps it open.

import React, { useEffect } from 'react'
import { PrefabDetail } from '../PrefabEditorPanel'
import { CustomAssetManager } from '../../lib/CustomAssetManager'
import FloatingWindow from '../FloatingWindow.jsx'

// The scrim and border went with the FloatingWindow conversion — the window
// draws its own frame, and there is no backdrop any more.
const C = {
  bg: '#16171a',
}

export default function PrefabEditModal({ prefab, onClose }) {
  // Escape closes, matching the other content-browser modals.
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  const handleSave = async (id, form) => {
    await CustomAssetManager.updatePrefab(id, form)
    onClose?.()
  }

  const handleDelete = async (id) => {
    await CustomAssetManager.deletePrefab(id)
    onClose?.()
  }

  return (
    <FloatingWindow
      id="prefab-edit"
      title={prefab?.name ? `PREFAB · ${prefab.name}` : 'PREFAB'}
      onClose={onClose}
      dockable={false}
      defaultSize={{ w: 460, h: 620 }}
    >
      <div
        data-testid="prefab-edit-modal"
        className="aos-thin-scroll"
        style={{ flex: 1, minHeight: 0, overflowY: 'auto', background: C.bg }}
      >
        <PrefabDetail
          prefab={prefab}
          animAssets={CustomAssetManager.listAnimationAssets()}
          audioAssets={CustomAssetManager.listAudioAssets()}
          onSave={handleSave}
          onDelete={handleDelete}
        />
      </div>
    </FloatingWindow>
  )
}
